import MembershipProfile from '@components/membership/membership-profile/MembershipProfile'
import { MembershipProfile as MembershipProfileModel } from '@models/membership/MembershipProfile'
import { Typography } from 'antd'

const { Text } = Typography

interface LiteMember {
  id: number
  firstName: string
  lastName: string
  email: string
  avatar: string | null
}

interface Props {
  member: LiteMember | null
}

/**
 * Renders the analytics read-model's lite `member` embed (ticket 537, API #298)
 * with the app's standard `MembershipProfile.Avatar` - profile picture, initials
 * fallback, link to the member - by mapping the embed onto the model shape.
 *
 * No program/plan tag comes out of it: the embed carries no `subscription`, so
 * `Avatar` skips the tag, which is what the analytics tables want since they
 * have a dedicated Plan column.
 */
const LiteMemberAvatar = ({ member }: Props) => {
  if (!member) {
    return <Text type="secondary">--</Text>
  }

  // Deliberately partial: the embed has no locale/code/createdAt, and
  // `isActive` must stay undefined so `Avatar` doesn't flag the member as
  // restricted (it only warns on an explicit `false`).
  const model = {
    id: member.id,
    firstName: member.firstName,
    lastName: member.lastName,
    email: member.email,
    profilePictureUrl: member.avatar ?? undefined,
  } as MembershipProfileModel

  return <MembershipProfile.Avatar model={model} />
}

export { LiteMemberAvatar }
